import { useSelector } from 'react-redux';

const useMiyoFee = () => {
  const { canMiyo, miyo } = useSelector((state) => state.pdpItem);

  // TODO assumes single face and asset, actually parse in memory design?
  const fee = canMiyo && !!miyo?.asset ? (miyo?.faceFee?.rate || 0) + (miyo?.assetFee?.rate || 0) : 0;

  return fee;
};

export default useMiyoFee;
